import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AddWellboreModalComponent } from 'app/modules/well-header-information/pages/wells/well/add-wellbore-modal/add-wellbore-modal.component';
import { EditWellModalComponent } from 'app/modules/well-header-information/pages/wells/well/edit-well-modal/edit-well-modal.component';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { WellClass } from 'app/modules/well-header-information/model/wells.model';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';

@Component({
  selector: 'app-well',
  templateUrl: './well.component.html',
  standalone: true,
  imports: [
    NgClass
  ],
  styleUrls: ['./well.component.scss']
})

export class WellComponent {
  public well: WellClass;

  constructor(
    private route: ActivatedRoute,
    private wellHeaderService: WellHeaderInfoService,
    private dialog: MatDialog,
  ) { }
  
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
       let wellId = params.get('wellId');
       this.getWell(wellId)
     });
   }

   getWell(id) {
    this.wellHeaderService.getWellsById(id).subscribe((res) => {
      this.well = {
        wellId: res.data.id,
        platformId: res.data.platformId,
        name: res.data.wellShortName,
        longName: res.data.wellLongName,
        slotNumber: res.data.slotNumber,
        status: res.data.wellStatus,
        latitude: res.data.latitude,
        longitude: res.data.longitude,
        uWI: res.data.uwi,
        createdDate: res.data.inputDate,
        level: 'Well'
      };
    })
  }

  addWellboreModal(wellDetails: any) {
    const dialogRef = this.dialog.open(AddWellboreModalComponent, {
      data: wellDetails.wellId,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(isSuccess => {
      if (isSuccess) {
        this.wellHeaderService.selectedWellPlatform$.subscribe(selectedPlatform => {
          this.wellHeaderService.getWellsTree(selectedPlatform.platformId).subscribe()
          this.wellHeaderService.updateParentsNode([this.well.wellId])
        })
      }
    });
  }

  editWellModal(wellData: any) {
    const dialogRef = this.dialog.open(EditWellModalComponent, {
      data: wellData,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(isSuccess => {
      if (isSuccess) {
        this.getWell(wellData.wellId)
      }
    });
  }

  handleDateFormat(dateString: string, withTime: boolean = false){
    return handleFormatDate(dateString,withTime)
  }
}
